import { Fragment } from "react";

/**
 * Dummy component for grouping map layers
 */
const Layers = Fragment;

export default Layers;
export { Layers };
